// Primeiro import: precisa inicializar antes de qualquer falha de boot.
import "./observability/instrument";
import { loadRuntimeConfig } from "@/config/runtime-config";

const root = document.getElementById("root");

try {
  await loadRuntimeConfig();
  const { mountApp } = await import("./mount-app");
  mountApp();
} catch (error) {
  if (root) {
    root.textContent =
      error instanceof Error
        ? `Configuração administrativa inválida: ${error.message}`
        : "Configuração administrativa inválida.";
    root.className = "configuration-error";
  }
}
